import { CircularProgress } from "@material-ui/core";

import { Overlay } from "../Overlay";

export const Compression = (): JSX.Element => (
  <Overlay>
    <CircularProgress />
  </Overlay>
);
